/*
©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
*/

import {html,Polymer} from '@polymer/polymer/polymer-legacy.js';

const template=html` `;
    
        var pushNotificationHelpers = {};

        pushNotificationHelpers.handleEvent = function (data) {

            

            
            if(data.userId != undefined ){
                data.forwardingData.notificationUserId = data.userId;
            }

            var eventData = {
                "forwardingState": data.forwardingData,
                "loginRequiredFlag": data.loginRequiredFlag,
                "gotoLocation": data.gotoLocation

            };
            var event = new CustomEvent('customNavigation', {
                'detail': eventData
            });

            window.dispatchEvent(event);

        };

        Polymer({
            is: 'firebase-push-notification',
            _template:template,
            properties: {

            },

            ready: function () {
                // check for device type
                if (channelType.android) {
                    document.addEventListener("deviceready", this._setupFCMDevice, false);
                } else if (channelType.iphone) {
                    document.addEventListener("deviceready", this._setupFCMDevice, false);
                } else if (!(getNavigationItem("userAgent").indexOf("MSIE ") > 0 || !!getNavigationItem("userAgent").match(/Trident.*rv:11\./))) {
                    // this._setupFCMWeb();
                }
            },


            _setupFCMDevice: function () {
                var groups = config.SpeedBoat.Modules.PushNotifications.Groups;
                if (!(typeof FCMPlugin !== 'undefined' && FCMPlugin)) {
                    //console.error("Push notification not supported for your device");
                    return;
                }
                FCMPlugin.onTokenRefresh(function (token) {

                    window.firebaseToken = token;
                });

                FCMPlugin.getToken(function (token) {
                        window.firebaseToken = token;

                    }, function(){

                    },
                    groups
                
                );

                FCMPlugin.onNotification(function (data) {

                    if (data.wasTapped) {
                        var userId = clientStorage.get(storageType.session, 'userId');

                        if (data.event) {
                            var event = JSON.parse(data.event);
                            
                            
                            if(  
                                (userId === null || userId === undefined) //not logged in
                                || (userId && event.userId && userId === event.userId) //logged in and userId = notification userId
                                || (event.userId === undefined)  //userId missing in notification
                                )

                           {
                                
                                window.pushNotificationTapped = true;
                                pushNotificationHelpers.handleEvent(event);

                            }
                            else {
                                //navigate to dashboard
                                // console.log("");
                            }

                        }
                     } else {
                            data = {};
                        }
                    });
                return;
            }



        });

        